{
  "loading": "Se încarcă...",
  "error": "Eroare",
  "cancel": "Anulare",
  "confirm": "Confirmare",
  "close": "Închidere",
  "open": "Deschidere",
  "ok": "OK",
  "yes": "Da",
  "no": "Nu",
  "continue": "Continuare",
  "back": "Înapoi",
  "next": "Următorul",
  "finish": "Finalizare",
  "save": "Salvare",
  "delete": "Ștergere",
  "edit": "Editare",
  "create": "Creare",
  "update": "Actualizare",
  "refresh": "Reîmprospătare",
  "success": "Succes",
  "warning": "Avertisment",
  "info": "Informație",
  "search-placeholder": "Căutare...",
  "message-input": "Introduceți-vă mesajul...",
  "please-log-in-to-access-this-page": "Vă rugăm să vă conectați pentru a accesa această pagină",
  "go-to-settings": "Mergeți la Setări",
  "go-back": "Mergeți înapoi",
  "welcome-user": "Bun venit, {$username}!",
  "notification-count": "{$count ->\n   [0] Nici o notificare\n   [1] O notificare\n   *[other] {$count} (de) notificări\n  }",
  "user-offline": "utilizatorul este offline",
  "user-offline-message": "{$source ->\n   [streamer] Se pare că <1>@{$handle} este offline</1>, dar recomandă să vizionați:\n   *[default] Se pare că <1>@{$handle} este offline</1>, dar vă recomandăm să vizionați:\n  }",
  "user-offline-no-recommendations": "Se pare că <1>@{$handle} este offline</1> acum.\nReveniți mai târziu.",
  "streaming-title": "transmisie în direct {$title}",
  "viewer-count": "{$count ->\n   [0] 0 vizionări\n   [1] 1 vizionare\n   *[other] {$count} (de) vizionări\n  }",
  "pds-selector-title": "Nou pe Atmosphere?",
  "pds-selector-description": "Va trebui să selectați un PDS (Personal Data Server) pentru a accesa aplicațiile de pe Atmosphere, cum ar fi Bluesky, Tangled și Spark.",
  "pds-selector-custom-label": "Alt PDS",
  "pds-selector-custom-description": "Introduceți adresa URL a propriei gazde PDS",
  "pds-selector-custom-url-label": "URL PDS personalizat",
  "pds-selector-custom-url-placeholder": "https://pds.exemplu.ro",
  "pds-selector-learn-more": "Aflați mai multe despre găzduirea proprie",
  "pds-selector-info": "Fiecare gazdă are propriile politici și standarde de fiabilitate. Datele dvs. ATProto se află pe gazda pe care o alegeți și le puteți migra ulterior. Notă: Streamplace are propriile reguli de moderare - accesul dvs. poate fi interzis pe Streamplace indiferent de gazda pe care o alegeți.",
  "pds-selector-read-policies": "Citiți <tosLink>Termenii și condițiile</tosLink> și <privacyLink>Politica de confidențialitate</privacyLink> ale {$label} înainte de a continua.",
  "pds-selector-handle-policy-checkbox": "Am citit și sunt de acord cu <policyLink>politica de gestionare</policyLink>",
  "login-show-live-on-bluesky": "Arată când sunt live pe Bluesky",
  "login-show-live-on-bluesky-description": "Adaugă inelul roșu LIVE avatarului dvs. de Bluesky în timp ce transmiteți și permite Streamplace să publice anunțuri în numele dvs. Debifați pentru a vă conecta fără a acorda niciun acces la contul dvs. de Bluesky."
}
